import type { RouteObject } from 'react-router-dom'

const employeeRoute: RouteObject = {
  children: [
    {
      children: [
        { lazy: () => import('@/pages/employees/employee-management/index/page'), path: '' },
        { lazy: () => import('@/pages/employees/employee-management/create/page'), path: 'create' },
        { lazy: () => import('@/pages/employees/employee-management/edit/page'), path: ':oid/edit' },
        { lazy: () => import('@/pages/employees/employee-management/detail/page'), path: ':oid' },
      ],
      path: 'employee-management',
    },
    {
      children: [
        { lazy: () => import('@/pages/employees/previous-employee/page'), path: '' },
        { lazy: () => import('@/pages/employees/previous-employee/detail/page'), path: ':oid' },
      ],
      path: 'previous-employee',
    },
  ],

  path: 'employees',
}

export default employeeRoute
